import React from "react"
import { useSpring, animated } from "react-spring"

const trans = (s) => `perspective(600px) scale(${s})`

function HoverCard({ children }) {
  const [propsAnimation, set] = useSpring(() => ({
    s: 1,
    opacity: 0.95,
  }))
  return (
    <animated.div
      onMouseEnter={() => set({ s: 1.1, opacity: 1 })}
      onMouseLeave={() => set({ s: 1, opacity: 0.95 })}
      style={{
        transform: propsAnimation.s.interpolate(trans),
        opacity: propsAnimation.opacity,
      }}
    >
      {children}
    </animated.div>
  )
}

export default HoverCard
